export function currentTimeInSeconds() {
  return Math.floor(Date.now() / 1000);
}
